import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {EventModel, EventParticipantModel} from '@/libs/Api';
import {EventsDataService} from '@/libs/events/events-data-service';
import {StoreName} from '@/libs/core/store/store-name';
import { EventParticipantsDataService } from '../event-particiants-data-service';

export const eventsStore = registerCrudStore<EventModel, EventModel>(StoreName.Event, new EventsDataService());
export const eventParticipantsStore = registerCrudStore<EventParticipantModel, EventParticipantModel>(StoreName.EventParticipant, new EventParticipantsDataService());
